<template>
  <div class="addtocart">
    <div v-if="isMobile() && isSubmodifier" class="btn cancel-btn" @click="$emit('canceled')">X</div>
    <div
      :style="isSushi ? '' :  'margin-top:30px'"
      v-if="
        product && product.ModifierGroups && product.ModifierGroups.length > 0
      "
      class="submodifier-scroll"
      :class="
        isSubmodifier ? !isSushi ? 'container-fluid pitem-modifier-details ios-scroll' : ' container-fluid ios-scroll pitem-modifier-details-sushi' : ''
      "
    >
      <div
        v-for="(groupID, index) in sortedModifierGroup"
        :key="index"
        :class="modifiers[groupID].inValid? 'invalid-modifier' : ''"
        :ref="groupID"
      >
        <h4
          v-if="modifiers[groupID] && modifiers[groupID].Modifiers.length > 0"
          class="m-0"
          :class="isSushi && 'montserrat-700' "
          :style="isSushi && 'font-size:24px'"
        >{{ modifiers[groupID].Name }}</h4>

        <!--    Todo clean this up-->
        <h6
          v-if="modifiers[groupID] && modifiers[groupID].Modifiers.length > 0"
          :style="isSushi && 'font-size:14px; color:#000000'"
           :class="modifiers[groupID].inValid ? isSushi ?  'color-red montserrat-400' : 'color-red' : isSushi ? 'montserrat-400 ' : ''"
        >{{ getGroupSpecification(groupID, modifiers[groupID]) }}<i v-if="modifiers[groupID].inValid" class="fa fa-warning ml-1"></i></h6>
        <ul
          class="list-unstyled d-flex flex-wrap mb-0"
          v-if="modifiers[groupID] && modifiers[groupID].Modifiers.length > 0"
        >
          <li
            v-for="md in modifiers[groupID].Modifiers"
            :key="md.ID"
            class="w-100 mb-3"
            :class="isModifierSoldOut(md)?'sold-out-md':''"
          >
            <div
              class="custom-checkbox md-container d-flex justify-content-between"
              :class="{
                'custom-control': !modifiers[groupID].IncludeQuantity,
                disabled: modifierDisabled(modifiers[groupID], md),
              }"
            >
              <Checkbox
                :style="getModifierNameStyle(md)"
                v-if="!modifiers[groupID].IncludeQuantity"
                :label="md.Name"
                v-model="md.IsSelected"
                :IsRadio="modifiers[groupID].IsSingleSel"
                @click="x => fixQuantity(modifiers[groupID], x, md, groupID)"
                :disabled="
                  (modifiers[groupID].MaximumDisable &&
                    !modifiers[groupID].IsSingleSel &&
                    !md.IsSelected) ||
                    isModifierSoldOut(md)
                "
                :isSushi="isSushi"
              ></Checkbox>
              <div
                v-if="modifiers[groupID].IncludeQuantity"
                class="d-flex"
                :style="getModifierNameStyle(md)"
              >
                <span class="qty-md d-flex md-qty-container align-self-baseline">
                  <button
                    :disabled="IsDisableDecreament(md, modifiers[groupID])"
                    class="btn-white btn-circle d-flex"
                    :style="desktopStyles.CommonColorTxt"
                    @click="decMdQty(md, modifiers[groupID], groupID)"
                  >
                    <span
                      class="material-icons small-material-icons btn-circle"
                    >remove_circle_outline</span>
                  </button>
                  <span class="d-flex align-items-center">{{ md.quantity || 0 }}</span>
                  <button
                    :disabled="IsDisableIncreament(md, modifiers[groupID])"
                    :style="desktopStyles.CommonColorTxt"
                    class="btn-white btn-circle d-flex"
                    @click="incMdQty(md, modifiers[groupID], groupID)"
                  >
                    <span class="material-icons small-material-icons btn-circle">add_circle_outline</span>
                  </button>
                </span>
                <label
                  @click="showSubmodifier(md)"
                  class="custom-control-label-without-box"
                >{{ md.Name }}</label>
              </div>
              <span v-if="isSubmodifier == false" :class="isSushi && 'montserrat-500 text-black'">{{ computePrice(md) | formatMoney(currencySign) }}</span>
              <div
                class="col-2 extra-price"
                style="width:20%"
                v-if="isSubmodifier == true"
              >{{ md.Price | formatMoney(currencySign) }}</div>
            </div>
            <ul
              class="modifiers-submodifiers-list"
              v-if="md.selectedSubmodifiers && isSubmodifier == false"
            >
              <li v-for="subMod in md.selectedSubmodifiers" :key="subMod.ID">{{ subMod.Name }}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="extras-footer" v-if="isSubmodifier == true && (isMobile() || hasConfirmButton)">
      <button
        type="button"
        class="btn btn-cancel"
        :style="mobileStyles.btn"
        @click="cancelModifiers()"
      >{{ $t("message.cancel") }}</button>
      <button
        type="button"
        :style="mobileStyles.btn"
        style="opacity:.85"
        class="btn btn-primary"
        @click="rollToProduct()"
      >
        <span
          style="float:left;"
        >{{ priceTrigger ? priceTrigger.Name : $t("message.confirm") }}</span>
        <span
          style="float:right;"
        >{{ rollIntoPrice | formatMoney(currencySign) }}</span>
        <!-- <span v-else style="float:right;">{{ $t("message.maximumQuantityExceeded") }}</span> -->
      </button>
    </div>
  </div>
</template>

<script>
import Checkbox from "../../shared/checkbox";
import { mapGetters } from "vuex";
import shared from "../../../sharedscripts/shop/products/Modifier.js";
export default {
  name: "Modifiers",
  components: { Checkbox },
  props: {
    priceTrigger: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    product: {
      type: Object,
      default: () => {}
    },
    modifiers: {
      type: Object,
      default: () => {}
    },
    price: {
      type: Number,
      default: 0
    },
    productId: {
      type: String,
      default: ""
    },
    initialModifiers: {
      type: Array,
      default: () => []
    },
    rollintoIndex: {
      type: Number,
      default: 0
    },
    isSubmodifier: {
      type: Boolean,
      default: false
    },
    ModifierGroupsStates: {
      type: Array,
      default: () => []
    },
    hasConfirmButton: {
      type: Boolean,
      default: false
    },
    selectedModifier: {
      type: Object,
      default: () => {}
    },
    isSushi: {
      type: Boolean
    }
  },
  watch: {
    ModifierGroupsStates: {
      handler: function() {
        this.checkMaximumSelection();
      },
      deep: true
    }
  },
  data() {
    return {
      quantity: 1,
      // maxItemQuantity: 20,
    };
  },
  mounted() {
    this.initModifiers();
    this.$forceUpdate();
    this.$nextTick(() => {
      const ids = this.sortedModifierGroup;
      if(Array.isArray(ids)) {
        const firstRequiredId = ids.find(id =>
          this.modifiers[id].MinimumSelection);
        if(firstRequiredId && ids.indexOf(firstRequiredId) > 0) {
          this.$refs[firstRequiredId][0].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
      this.autoSelectMinimumVariants();
      this.$forceUpdate();
    });
  },
  computed: {
    ...shared.computed,
    ...mapGetters([
      "viewConfig",
      "desktopStyles",
      "mobileStyles",
      "canshowRollInto"
    ]),
    showRollIntoProduct() {
      return this.canshowRollInto({ ...this.product, quantity: this.quantity });
    },
    rollIntoPrice() {
      var result = 0;
      this.getModifiers().forEach(element => {
        result += element.Price;
      });
      return this.priceTrigger
        ? this.priceTrigger.FixedPriceValue + result
        : this.selectedModifier ? this.selectedModifier.Price + result : result;
    }
  },
  methods: {
    ...shared.methods
  }
};
</script>
